// In-house cart: the "Ajouté au panier" panel (sections/mnl-cart-panel.liquid, opened after every add)
// and the /cart page (sections/main-cart.liquid). Both are rendered server-side from the same snippets;
// this file only opens the panel, sends cart writes and swaps in the HTML Shopify returns with them
// (Section Rendering API). Every embroidery decision is a pure function of
// assets/embroidery-cart-core.js, which must load before this file.
(function () {
  var core = window.EmbroideryCartCore;
  var RETRY = 'Mise à jour impossible, réessayez.';
  var BLOCKED = {
    max: "Augmentez la quantité de l'article pour ajouter plus de broderies à cette zone.",
    'garment-decrease': "Vous devez d'abord supprimer une personnalisation avant de réduire la quantité de cet article.",
    missing: RETRY
  };
  // Marks our own writes so the resource observer below doesn't refresh on them a second time.
  var OWN = 'mnl-cart=1';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?$/;

  var queue = Promise.resolve();
  var paintSeq = 0;
  // True between an add with a confirmed embroidery widget and embroidery-app's cart:build.
  var pending = false;
  var pendingTimer = null;
  // Line keys the panel shows, in order: the add that opened it, then the suggestions added from it.
  var added = [];
  // Page the sections are rendered for: the added product's, so the panel's suggestions come from the
  // lines it shows only (sections/mnl-cart-panel.liquid, snippets/mnl-cart-recos.liquid). Null: the
  // current page.
  var context = null;
  function contextPath() { return context || window.location.pathname; }

  function roots() { return Array.prototype.slice.call(document.querySelectorAll('[data-mnl-cart]')); }
  // The panel's <dialog> (layout/theme.liquid); none on /cart.
  function dialog() { return document.querySelector('[data-mnl-cart-panel]'); }
  function sectionIds() { return roots().map(function (root) { return root.dataset.sectionId; }); }

  function linesOf(root) {
    var el = root && root.querySelector('[data-mnl-cart-lines]');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  }

  var WAIVED = '_embroidery_offer_waived';
  var CONFLICT_TEXT = "Ce code promo n'est pas cumulable avec l'offre broderie. Choisissez l'avantage à garder pour passer commande.";
  // Applied promo codes + offer waiver rendered with the lines (snippets/mnl-cart-lines.liquid),
  // run through the same decision as the checkout guard.
  function discountStateOf(root) {
    var el = root && root.querySelector('[data-mnl-cart-discount-state]');
    var raw = { codes: [], waived: false };
    try { if (el) raw = JSON.parse(el.textContent); } catch (e) {}
    return core.discountConflictState(linesOf(root), window.EmbroideryOffer || null, raw.codes || [], !!raw.waived);
  }

  var cleaningWaiver = false;
  var cleanedWaiverFor = null;
  var announcedFor = null; // codes signature whose conflict sentence was already announced
  // A waiver whose code is gone must not keep billing embroidery at full price (checkout does the
  // same). At most once per observed state and never while it is in flight: a failure is not retried.
  function clearStaleWaiver(state) {
    var signature = state.exemptAppliedCodes.join('|');
    if (cleaningWaiver || cleanedWaiverFor === signature) return;
    cleaningWaiver = true;
    cleanedWaiverFor = signature;
    var attributes = {};
    attributes[WAIVED] = '';
    mutate('/cart/update.js', { attributes: attributes })
      .catch(function () {})
      .then(function () { cleaningWaiver = false; });
  }

  function conflictButton(attribute, label, linkStyle) {
    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute(attribute, '');
    button.className = linkStyle ? 'mnl-cart-discount__remove' : 'mnl-cart-discount__btn';
    button.textContent = label;
    return button;
  }

  // Fills the /cart page's notice (sections/main-cart.liquid); the side cart has no such container.
  function renderConflict(root, state) {
    var box = root.querySelector('[data-mnl-cart-discount-conflict]');
    if (!box) return;
    box.textContent = '';
    // The box is rebuilt on every repaint, so a screen reader never hears it: announce the conflict
    // once per codes signature through the existing role="status" message, and clear it afterwards.
    var status = root.querySelector('[data-mnl-cart-discount-msg]');
    var signature = state.conflict ? state.nonExemptCodes.join('|') : null;
    if (status && signature !== announcedFor) {
      status.textContent = state.conflict ? CONFLICT_TEXT : '';
      announcedFor = signature;
    }
    box.hidden = !(state.conflict || state.waivedWithCode);
    if (box.hidden) return;
    var text = document.createElement('p');
    text.textContent = state.conflict
      ? CONFLICT_TEXT
      : 'Offre broderie désactivée : votre code promo est appliqué.';
    box.appendChild(text);
    if (state.conflict) {
      box.appendChild(conflictButton('data-mnl-cart-keep-offer', "Garder l'offre broderie"));
      box.appendChild(conflictButton('data-mnl-cart-keep-code', 'Utiliser le code promo'));
    } else {
      box.appendChild(conflictButton('data-mnl-cart-restore-offer', "Revenir à l'offre broderie", true));
    }
  }

  // Loader on every displayed row (panel and /cart page) holding one of these line keys. Returns
  // the undo for an error; on success the repaint replaces the rows.
  function setLoading(keys) {
    var rows = Array.prototype.slice.call(document.querySelectorAll('[data-mnl-cart] [data-mnl-cart-keys]'))
      .filter(function (row) {
        return row.dataset.mnlCartKeys.split(',').some(function (key) { return keys.indexOf(key) !== -1; });
      });
    rows.forEach(function (row) { row.classList.add('is-loading'); });
    return function () { rows.forEach(function (row) { row.classList.remove('is-loading'); }); };
  }

  function showError(message) {
    roots().forEach(function (root) {
      var el = root.querySelector('[data-mnl-cart-error]');
      if (el) el.textContent = message;
    });
  }

  // Spinner in a CTA until the page leaves (label kept for screen readers, see mnl-cart.css).
  function busy(el, on) {
    el.classList.toggle('is-loading', on);
    el.setAttribute('aria-busy', on);
  }

  function lineMessage(row, message) {
    var el = row.querySelector('[data-mnl-cart-line-msg]');
    if (!el) return;
    el.textContent = message;
    clearTimeout(el.mnlTimer);
    el.mnlTimer = setTimeout(function () { el.textContent = ''; }, 4000);
  }

  // Greys "+" on embroidery cards at their garment's cap and reveals the offer badges - both replay
  // the server rules from the lines JSON rendered with the section.
  function decorate(root) {
    // Server-rendered hidden <li>: paint replaces the markup, so the flag is re-applied here.
    root.querySelectorAll('[data-mnl-cart-pending]').forEach(function (li) { li.hidden = !pending; });
    // Panel: the added lines' rows and the embroidery rows drawn under each (--linked,
    // snippets/mnl-cart-lines.liquid), in the order they were added (cart.items lists the newest first).
    var rank = -1;
    root.querySelectorAll('.mnl-cart-line').forEach(function (row) {
      if (!row.classList.contains('mnl-cart-line--linked')) rank = added.indexOf(row.dataset.mnlCartKeys);
      row.classList.toggle('is-added', rank !== -1);
      row.style.order = rank === -1 ? '' : rank;
    });
    eta(root);
    if (!core) return;
    var items = linesOf(root);
    var maxed = core.maxedGarmentProductIds(items);
    root.querySelectorAll('[data-mnl-cart-job]').forEach(function (row) {
      var plus = row.querySelector('[data-mnl-cart-action="plus"]');
      if (!plus) return;
      var isMaxed = !!maxed[row.dataset.garmentProductId];
      plus.classList.toggle('is-maxed', isMaxed);
      plus.setAttribute('aria-disabled', isMaxed ? 'true' : 'false');
      if (isMaxed) plus.title = BLOCKED.max;
      else plus.removeAttribute('title');
    });
    var state = discountStateOf(root);
    // Waived offer: the Cart Transform bills embroidery at full price, so no "offerte" badge.
    var offer = window.EmbroideryOffer || null;
    var offered = core.offeredLineKeys(items, state.waivedWithCode || state.staleWaiver ? Object.assign({}, offer, { active: false }) : offer);
    renderConflict(root, state);
    // A new stale episode must be cleaned again; while the same one persists a failure isn't retried.
    if (state.staleWaiver) clearStaleWaiver(state); else cleanedWaiverFor = null;
    root.querySelectorAll('[data-mnl-offer-key]').forEach(function (badge) {
      badge.hidden = !offered[badge.dataset.mnlOfferKey];
    });
  }

  // Delivery date of snippets/mnl-cart-eta.liquid, recomputed here: its Liquid 'now' is the time the
  // HTML was rendered, which a 304 can serve hours later. Same rule in Paris time: next business day,
  // the one after from 14:00.
  function eta(root) {
    var date = root.querySelector('[data-mnl-cart-eta-date]');
    var when = root.querySelector('[data-mnl-cart-eta-when]');
    if (!date || !when) return;
    var now = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date())
      .forEach(function (part) { now[part.type] = +part.value; });
    var late = now.hour >= 14;
    var day = new Date(Date.UTC(now.year, now.month - 1, now.day));
    for (var left = late ? 2 : 1; left > 0;) {
      day.setUTCDate(day.getUTCDate() + 1);
      var weekday = day.getUTCDay();
      if (weekday !== 0 && weekday !== 6) left--;
    }
    date.textContent = day.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
    when.innerHTML = late ? "aujourd'hui" : '<b>avant 14h</b>';
  }

  // The innerHTML swap drops focus: put it back on the same control of the same row, or on the
  // close button when the row is gone, so keyboard users never land on <body> behind the modal.
  function focusTarget() {
    var el = document.activeElement;
    var row = el && el.closest && el.closest('[data-mnl-cart-keys]');
    return row && el.dataset.mnlCartAction ? { keys: row.dataset.mnlCartKeys, action: el.dataset.mnlCartAction } : null;
  }

  function restoreFocus(target) {
    if (!target) return;
    var rows = document.querySelectorAll('[data-mnl-cart-keys]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].dataset.mnlCartKeys !== target.keys) continue;
      var button = rows[i].querySelector('[data-mnl-cart-action="' + target.action + '"]');
      if (button) return button.focus();
    }
    var d = dialog();
    var close = d && d.open && d.querySelector('[data-mnl-cart-close]');
    if (close) close.focus();
  }

  // Returns false when a root got no HTML (sections[id] null/absent) and so kept its stale markup.
  function paint(sections) {
    var target = focusTarget();
    var complete = true;
    roots().forEach(function (root) {
      var html = sections && sections[root.dataset.sectionId];
      var fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mnl-cart]');
      if (!fresh) return (complete = false);
      root.innerHTML = fresh.innerHTML;
      decorate(root);
    });
    restoreFocus(target);
    watchCheckout();
    return complete;
  }

  // Rejects with the parsed JSON body only for a JSON error (Shopify cart error, 422 from the Cart
  // Validation Function); an HTML 429/5xx or a network failure rejects with {} -> RETRY text.
  function post(path, body) {
    body.sections = sectionIds();
    body.sections_url = contextPath();
    return fetch(path + '?' + OWN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.ok) return res.json();
      return res.json().then(function (json) { throw json; }, function () { throw {}; });
    });
  }

  // Serialized: concurrent cart writes clobber each other on Shopify's side.
  function mutate(path, body) {
    var run = queue.then(function () { return post(path, body); });
    queue = run.catch(function () {});
    return run.then(
      function (cart) {
        paintSeq++;
        // A missing section would leave the clicked row stuck in is-loading: re-render once.
        if (!paint(cart.sections)) refresh();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      },
      function (error) {
        // A 422 from the Cart Validation Function carries its message in `description`; anything
        // else (SyntaxError, "Failed to fetch") is technical text a shopper must never see.
        showError((error && error.description) || RETRY);
        throw error;
      }
    );
  }

  // Re-caps embroidery above its garment and resyncs the zones of a job, same rule as the server.
  // No-op (no request) on a healthy cart.
  function heal(items) {
    if (!core) return;
    var corrections = core.computeQuantityCorrections(items || []);
    if (!corrections.length) return;
    var updates = {};
    corrections.forEach(function (c) { updates[c.item.key] = c.quantity; });
    mutate('/cart/update.js', { updates: updates }).catch(setLoading(Object.keys(updates)));
  }

  // One atomic /cart/update.js keyed by line key: a multi-line change lands entirely or not at all.
  function updateLines(updates) {
    return mutate('/cart/update.js', { updates: updates }).then(function (cart) {
      heal(cart.items);
      return cart;
    });
  }

  var refreshTimer = null;
  var refreshWaiters = [];
  // Re-render from the server cart. Coalesced: one add fires ajaxProduct:added, cart:build and the
  // resource observer within a few ms - one request answers all three.
  function refresh() {
    return new Promise(function (resolve) {
      refreshWaiters.push(resolve);
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        var waiters = refreshWaiters;
        refreshWaiters = [];
        var done = function () { waiters.forEach(function (w) { w(); }); };
        var ids = sectionIds();
        if (!ids.length) return done();
        var seq = ++paintSeq;
        fetch(contextPath() + '?sections=' + ids.join(','))
          .then(function (res) { return res.json(); })
          .then(function (sections) {
            if (seq === paintSeq) paint(sections); // a newer write already painted
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(function () {})
          .then(done);
      }, 50);
    });
  }

  function open() {
    var d = dialog();
    if (!d || !d.showModal) return;
    // Reopened during the close animation: cancel the pending close instead of ignoring the click.
    if (d.open) return d.classList.add('is-open');
    d.showModal();
    d.getBoundingClientRect(); // commit the off-screen position so the slide-in transitions
    d.classList.add('is-open');
  }

  function close() {
    var d = dialog();
    if (!d || !d.open) return;
    d.classList.remove('is-open');
    // A navigation stopped (Esc, Stop) leaves "Continuer vers mon panier" spinning.
    d.querySelectorAll('.mnl-cart-cta').forEach(function (cta) { busy(cta, false); });
    var finish = function () {
      if (d.open && !d.classList.contains('is-open')) d.close();
    };
    d.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 400); // transitionend never fires if nothing actually moved
  }

  // Header cart icon: a <span role="button"> whose click goes to /cart (link-to-decode,
  // layout/theme.liquid) - give it the keyboard a button has.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var icon = event.target.closest && event.target.closest('.js-drawer-open-cart');
    if (!icon) return;
    event.preventDefault();
    icon.click();
  });

  // Escape: animate out instead of the dialog's instant close.
  document.addEventListener('cancel', function (event) {
    if (event.target !== dialog()) return;
    event.preventDefault();
    close();
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mnl-cart-close]')) return close();
    if (event.target === dialog()) return close(); // ::backdrop clicks target the dialog itself
    // "Continuer vers mon panier"; a modified click (new tab, download) or a cancelled one leaves this page as it is.
    var cta = event.target.closest('a.mnl-cart-cta');
    if (cta && !(event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button || event.defaultPrevented)) return busy(cta, true);

    if (event.target.closest('[data-mnl-cart-discount-remove]')) {
      mutate('/cart/update.js', { discount: '' }).catch(function () {});
      return;
    }

    var choice = core && event.target.closest('[data-mnl-cart-keep-offer], [data-mnl-cart-keep-code], [data-mnl-cart-restore-offer]');
    if (choice) {
      var state = discountStateOf(choice.closest('[data-mnl-cart]'));
      var body = {};
      if (!choice.hasAttribute('data-mnl-cart-keep-code')) body.discount = state.exemptAppliedCodes.join(',');
      if (!choice.hasAttribute('data-mnl-cart-keep-offer')) {
        body.attributes = {};
        body.attributes[WAIVED] = choice.hasAttribute('data-mnl-cart-keep-code') ? 'true' : '';
      }
      mutate('/cart/update.js', body).catch(function () {});
      return;
    }

    var button = event.target.closest('[data-mnl-cart-action]');
    var row = button && button.closest('[data-mnl-cart-keys]');
    var root = row && row.closest('[data-mnl-cart]');
    if (!root || !core) return;
    var plan = core.planLineAction(linesOf(root), row.dataset.mnlCartKeys.split(','), button.dataset.mnlCartAction);
    if (plan.blocked) return lineMessage(row, BLOCKED[plan.blocked] || RETRY);
    updateLines(plan.updates).catch(setLoading(Object.keys(plan.updates)));
  });

  document.addEventListener('submit', function (event) {
    var discount = event.target.closest('[data-mnl-cart-discount]');
    if (discount) {
      event.preventDefault();
      var code = discount.elements.discount.value.trim();
      if (!code) return;
      mutate('/cart/update.js', { discount: code })
        .then(function (cart) {
          var applied = (cart.discount_codes || []).some(function (d) {
            return d.applicable && d.code.toLowerCase() === code.toLowerCase();
          });
          var message = document.querySelector('[data-mnl-cart-discount-msg]');
          if (!applied && message) message.textContent = "Ce code n'est pas applicable à votre panier.";
        })
        .catch(function () {});
      return;
    }

    var checkout = event.target.closest('[data-mnl-cart-checkout]');
    if (!checkout || checkout.dataset.validated) return;
    event.preventDefault();
    // The recap's button or the pinned bar's (form=): both disabled, the spinner on the one clicked.
    var buttons = submitButtons(checkout);
    var submit = event.submitter || buttons[0];
    buttons.forEach(function (button) { button.disabled = true; });
    if (submit) busy(submit, true);
    // Empty /cart/update.js: the only way to surface a Cart Validation Function error before
    // leaving for checkout - Liquid has no cart.errors for it.
    fetch('/cart/update.js?' + OWN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: '{}'
    })
      .then(function (res) {
        if (res.ok) {
          checkout.dataset.validated = '1';
          return checkout.submit();
        }
        return res.json().then(function (json) {
          showError(json.description || RETRY);
          buttons.forEach(function (button) { button.disabled = false; });
          if (submit) busy(submit, false);
          // The pinned mobile checkout bar is far from the error line at the end of the page
          // (checkout only exists on /cart, which renders no panel: one error element).
          var error = document.querySelector('[data-mnl-cart-error]');
          if (error) error.scrollIntoView({ block: 'center' });
        });
      })
      .catch(function () { checkout.submit(); });
  });

  // Back from checkout (bfcache): the restored page shows the cart as it was and a checkout button
  // left disabled/validated - re-render from the server, re-arm every checkout form and stop the
  // CTA spinners.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    refresh();
    document.querySelectorAll('[data-mnl-cart-checkout]').forEach(function (form) {
      delete form.dataset.validated;
      submitButtons(form).forEach(function (button) { button.disabled = false; });
    });
    document.querySelectorAll('.mnl-cart-cta').forEach(function (cta) { busy(cta, false); });
  });

  // form.elements also holds the buttons outside the form that point to it with form=.
  function submitButtons(form) {
    return Array.prototype.filter.call(form.elements, function (el) { return el.type === 'submit'; });
  }

  // /cart on phones/tablets: the pinned checkout bar (.mnl-cart-sticky) shows only while the recap's
  // own checkout button is off screen. Re-armed after every paint: the swap replaces the form.
  var ctaObserver = window.IntersectionObserver && new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var root = entry.target.closest('[data-mnl-cart]');
      if (root) root.classList.toggle('is-sticky', !entry.isIntersecting);
    });
  });
  function watchCheckout() {
    if (!ctaObserver) return;
    ctaObserver.disconnect();
    roots().forEach(function (root) {
      var form = root.querySelector('[data-mnl-cart-checkout]');
      if (form) ctaObserver.observe(form);
      else root.classList.remove('is-sticky'); // emptied cart: no bar left
    });
  }

  function setPending(on) {
    pending = on;
    clearTimeout(pendingTimer);
    // No cart:build when embroidery-app's add fails (it reopens its popup instead).
    if (on) pendingTimer = setTimeout(function () { setPending(false); }, 10000);
    roots().forEach(decorate);
  }

  // The suggestions' script (popups, add), loaded with the first add rather than on every page.
  function loadRecos() {
    var d = dialog();
    if (!d || !d.dataset.recosSrc || loadRecos.done) return;
    loadRecos.done = true;
    var script = document.createElement('script');
    script.src = d.dataset.recosSrc;
    document.head.appendChild(script);
  }

  document.addEventListener('ajaxProduct:added', function (event) {
    // The /cart/add.js line (theme product form, shoppable look); {items: [...]} for a multi-item add.
    var line = (event.detail && event.detail.product) || {};
    var key = line.key || (line.items && line.items[0] && line.items[0].key);
    added = key ? [key] : [];
    // The panel is rendered for this product's page until the next add from a product form; the
    // suggestions added from the panel sit above its line in cart.items, the Liquid takes them too.
    var handle = line.handle || (line.items && line.items[0] && line.items[0].handle);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    context = dialog() && handle ? root + 'products/' + encodeURIComponent(handle) : null;
    // embroidery-app's own ajaxProduct:added listener then adds the embroidery of every confirmed
    // widget: show a pending row until its cart:build.
    // Third-party API: a throw here must never cost the panel its refresh/open.
    try {
      var zones = window.EmbroideryZoneState;
      var widgets = document.querySelectorAll('[data-embroidery-widget]');
      if (zones && Array.prototype.some.call(widgets, function (w) { return zones.forWidget(w).isConfirmed(); })) setPending(true);
    } catch (e) {}
    loadRecos();
    refresh().then(function () {
      var d = dialog();
      if (!d) return;
      // No HTML came back (request failed, section null): the cart page rather than an empty panel.
      if (!d.querySelector('[data-mnl-cart-close]')) return window.location.assign('/cart');
      open();
    });
  });
  // embroidery-app dispatches cart:build once the embroidery lines follow the garment.
  document.addEventListener('cart:build', function () { refresh().then(function () { setPending(false); }); });

  // Cart writes made by other scripts (BOGOS free gift, msclkid attribute, apps) fire none of our
  // events. Resource Timing sees every fetch/XHR without patching window.fetch.
  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (entry.name.indexOf(OWN) === -1 && CART_WRITE.test(entry.name.split('?')[0])) refresh();
        });
      }).observe({ type: 'resource' });
    } catch (e) {}
  }

  roots().forEach(decorate);
  // A /cart tab left open across 14:00 (or midnight) gets no repaint.
  setInterval(function () { roots().forEach(eta); }, 60000);
  watchCheckout();
  heal(linesOf(roots()[0]));

  window.MnlCart = {
    open: open,
    close: close,
    refresh: refresh,
    // A suggestion added from the panel joins its rows (assets/mnl-cart-recos.js).
    showLine: function (key) { if (key && added.indexOf(key) === -1) added.push(key); }
  };
})();
